import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'

import CssBaseline from '@material-ui/core/CssBaseline'
import PropTypes from 'prop-types'
import { Head } from '@inertiajs/react'
import { PageProvider } from './Page.context'
import { usePage } from './Page.hooks'

const Page = props => {
	const [{ theme, children, metaData, fontList }] = usePage(props)

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<PageProvider value={metaData}>{children}</PageProvider>
			{!_.isEmpty(fontList) && (
				<Head>
					{_.map(fontList, font => (
						<link key={font.key} head-key={font.key} rel="stylesheet" href={font.url} />
					))}
				</Head>
			)}
		</ThemeProvider>
	)
}

Page.propTypes = {
	// eslint-disable-next-line react/no-unused-prop-types
	children: PropTypes.node,
}

Page.defaultProps = {
	children: null,
}

export default Page
